<script setup lang="ts">
import { i18n } from '@/i18n';

const props = withDefaults(
  defineProps<{
    isBaseBusiness?: boolean;
  }>(),
  {}
);

const t = i18n.t;

defineEmits<{ (e: 'click', isBaseBusiness: boolean): void }>();
</script>
<template>
  <div class="edit-business-tab__container">
    <button
      :class="props.isBaseBusiness ? 'edit-business-tab__button--inactive' : 'edit-business-tab__button--active'"
      @click="() => $emit('click', false)"
    >
      {{ t('仕入取引') }}
    </button>
    <button
      :class="props.isBaseBusiness ? 'edit-business-tab__button--active' : 'edit-business-tab__button--inactive'"
      @click="() => $emit('click', true)"
    >
      {{ t('販売取引') }}
    </button>
  </div>
</template>
<style lang="scss" scoped>
.edit-business-tab {
  &__container {
    display: grid;
    grid-template-columns: max-content max-content auto;
    grid-gap: 10px;
    height: 30px;
  }

  &__button {
    &--active {
      color: $textDefault;
      height: 30px;
      border-bottom: 2px solid $semanticPrimary;
      text-align: center;
      font-family: Noto Sans JP;
      font-size: $fontSizeS;
      font-weight: 700;
      letter-spacing: 0em;
    }

    &--inactive {
      color: $textSecondary;
      height: 30px;
      text-align: center;
      font-family: Noto Sans JP;
      font-size: $fontSizeS;
      font-weight: 500;
      letter-spacing: 0em;
    }
  }
}
</style>
